[
  {
    "id": "oldschool",
    "name": "Old school",
    "sub": "'79–'85, drum machines",
    "group": "classic",
    "bpmDefault": 110,
    "swingDefault": 50,
    "flavor": "crisp",
    "crateKeywords": [
      "disco",
      "funk",
      "electro",
      "boogie",
      "break"
    ]
  },
  {
    "id": "golden",
    "name": "Golden age",
    "sub": "'86–'90, breaks & samplers",
    "group": "classic",
    "bpmDefault": 100,
    "swingDefault": 56,
    "flavor": "dusty",
    "crateKeywords": [
      "funk",
      "soul",
      "break",
      "45",
      "drums"
    ]
  },
  {
    "id": "tribe",
    "name": "Native Tongues",
    "sub": "Jazz-rap, upright bass",
    "group": "classic",
    "bpmDefault": 92,
    "swingDefault": 58,
    "flavor": "crisp",
    "crateKeywords": [
      "soul jazz",
      "cti",
      "upright",
      "vibraphone",
      "fusion"
    ]
  },
  {
    "id": "premier",
    "name": "NY boom bap",
    "sub": "Chops & scratches",
    "group": "classic",
    "bpmDefault": 90,
    "swingDefault": 57,
    "flavor": "punch",
    "crateKeywords": [
      "jazz",
      "soul",
      "library",
      "soundtrack",
      "piano"
    ]
  },
  {
    "id": "peterock",
    "name": "Soul boom bap",
    "sub": "Horns & filtered bass",
    "group": "classic",
    "bpmDefault": 94,
    "swingDefault": 60,
    "flavor": "dusty",
    "crateKeywords": [
      "soul jazz",
      "horns",
      "sax",
      "organ",
      "70s soul"
    ]
  },
  {
    "id": "wu",
    "name": "Wu-Tang dirt",
    "sub": "Grimy, detuned soul",
    "group": "classic",
    "bpmDefault": 90,
    "swingDefault": 55,
    "flavor": "grit",
    "crateKeywords": [
      "soul",
      "stax",
      "southern soul",
      "kung fu",
      "piano"
    ]
  },
  {
    "id": "qb",
    "name": "Queensbridge grime",
    "sub": "Dark mid-90s NYC",
    "group": "classic",
    "bpmDefault": 90,
    "swingDefault": 52,
    "flavor": "punch",
    "crateKeywords": [
      "jazz",
      "fusion",
      "soundtrack",
      "minor",
      "piano"
    ]
  },
  {
    "id": "gfunk",
    "name": "G-funk",
    "sub": "West Coast bounce",
    "group": "classic",
    "bpmDefault": 94,
    "swingDefault": 55,
    "flavor": "clean",
    "crateKeywords": [
      "p-funk",
      "funk",
      "talkbox",
      "boogie",
      "70s soul"
    ]
  },
  {
    "id": "south",
    "name": "Dirty South funk",
    "sub": "'94–'00 live funk",
    "group": "classic",
    "bpmDefault": 76,
    "swingDefault": 52,
    "flavor": "clean",
    "crateKeywords": [
      "southern soul",
      "gospel",
      "funk",
      "organ"
    ]
  },
  {
    "id": "memphis",
    "name": "Memphis",
    "sub": "90s tape horror",
    "group": "classic",
    "bpmDefault": 136,
    "swingDefault": 50,
    "flavor": "grit",
    "crateKeywords": [
      "horror",
      "soundtrack",
      "synth",
      "80s"
    ]
  },
  {
    "id": "chipmunk",
    "name": "Chipmunk soul",
    "sub": "Sped-up vocals, big drums",
    "group": "classic",
    "bpmDefault": 90,
    "swingDefault": 55,
    "flavor": "punch",
    "crateKeywords": [
      "soul",
      "philly soul",
      "northern soul",
      "vocal group"
    ]
  },
  {
    "id": "dilla",
    "name": "Dilla / off-grid",
    "sub": "Drunk swing, soul chops",
    "group": "classic",
    "bpmDefault": 90,
    "swingDefault": 60,
    "flavor": "dusty",
    "crateKeywords": [
      "soul",
      "fusion",
      "brazilian",
      "soft rock",
      "aor"
    ]
  },
  {
    "id": "madvillain",
    "name": "Abstract / Madvillain",
    "sub": "Dusty collage",
    "group": "classic",
    "bpmDefault": 88,
    "swingDefault": 56,
    "flavor": "grit",
    "crateKeywords": [
      "brazilian",
      "bollywood",
      "library",
      "lounge",
      "psych",
      "exotica"
    ]
  },
  {
    "id": "jazz",
    "name": "Jazz-hop",
    "sub": "Warm, dusty, relaxed",
    "group": "classic",
    "bpmDefault": 80,
    "swingDefault": 62,
    "flavor": "soft",
    "crateKeywords": [
      "jazz",
      "bossa nova",
      "piano trio",
      "rhodes",
      "japanese jazz"
    ]
  },
  {
    "id": "griselda",
    "name": "Drumless / Griselda",
    "sub": "Revival: raw loops",
    "group": "classic",
    "bpmDefault": 86,
    "swingDefault": 54,
    "flavor": "minimal",
    "crateKeywords": [
      "prog",
      "psych",
      "library",
      "italian soundtrack",
      "soul"
    ]
  },
  {
    "id": "trap",
    "name": "Trap",
    "sub": "Atlanta, 808-driven",
    "group": "modern",
    "bpmDefault": 140,
    "swingDefault": 50,
    "flavor": "clip",
    "crateKeywords": [
      "soundtrack",
      "ambient",
      "choir",
      "strings",
      "synth"
    ]
  },
  {
    "id": "drill",
    "name": "Drill",
    "sub": "UK / NY sliding 808s",
    "group": "modern",
    "bpmDefault": 142,
    "swingDefault": 50,
    "flavor": "clip",
    "crateKeywords": [
      "soundtrack",
      "ambient",
      "choir",
      "strings",
      "synth"
    ]
  },
  {
    "id": "phonk",
    "name": "Drift phonk",
    "sub": "Distorted cowbells",
    "group": "modern",
    "bpmDefault": 130,
    "swingDefault": 50,
    "flavor": "clip",
    "crateKeywords": [
      "soundtrack",
      "ambient",
      "choir",
      "strings",
      "synth"
    ]
  },
  {
    "id": "cloud",
    "name": "Cloud rap",
    "sub": "Hazy, ambient",
    "group": "modern",
    "bpmDefault": 140,
    "swingDefault": 50,
    "flavor": "soft",
    "crateKeywords": [
      "soundtrack",
      "ambient",
      "choir",
      "strings",
      "synth"
    ]
  },
  {
    "id": "rage",
    "name": "Rage",
    "sub": "Supersaws, clipped 808s",
    "group": "modern",
    "bpmDefault": 160,
    "swingDefault": 50,
    "flavor": "clip",
    "crateKeywords": [
      "soundtrack",
      "ambient",
      "choir",
      "strings",
      "synth"
    ]
  },
  {
    "id": "melodic",
    "name": "Melodic rap",
    "sub": "Polished, vocal-first",
    "group": "modern",
    "bpmDefault": 145,
    "swingDefault": 50,
    "flavor": "clean",
    "crateKeywords": [
      "soundtrack",
      "ambient",
      "choir",
      "strings",
      "synth"
    ]
  }
]
